import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AudioPlayer from './AudioPlayer';
import NavBar from './NavBar';
import GiftBanner from './GiftBanner';
import PromoBanner from './PromoBanner';
import SiteFooter from './SiteFooter';
import { isPromoActive } from '../data/promo-config';

/* Routes that have their own dedicated footer — skip the sitewide one. */
const NO_SITE_FOOTER_ROUTES = ['/gangsta-ai', '/make-music-ai'];

export default function Layout() {
  const isGangstaAIDomain = window.location.hostname.includes('gangstaaifordummies');
  const promoActive = isPromoActive();
  const { pathname } = useLocation();
  const showSiteFooter =
    !isGangstaAIDomain &&
    !NO_SITE_FOOTER_ROUTES.some((p) => pathname.startsWith(p));

  return (
    <div className={`alchemy-app ${isGangstaAIDomain ? 'gai-standalone' : ''}`} data-testid="alchemy-app">
      {!isGangstaAIDomain && (promoActive ? <PromoBanner /> : <GiftBanner />)}
      {!isGangstaAIDomain && <NavBar />}
      {!isGangstaAIDomain && <AudioPlayer />}
      <Outlet />
      {showSiteFooter && <SiteFooter />}
    </div>
  );
}
